import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { CustomTooltip, TextMidCut } from "../../../../../../../../common/components";
import styles from "./DocumentNameHandler.module.css";

export default () => {
	const documentName = useSelector(({ srDocument }) => srDocument.documentName);
	const [overflowDocName, setOverflowDocName] = useState(false);
	const containerRef = useRef(null);
	useEffect(() => {
		const handleLogoSize = () => {
			setOverflowDocName(containerRef.current?.scrollWidth <= 123);
		};
		handleLogoSize();
		window.addEventListener("resize", handleLogoSize);
		return () => {
			window.removeEventListener("resize", handleLogoSize);
		};
	}, []);
	return (
		<CustomTooltip title={overflowDocName && documentName}>
			<div ref={containerRef} className={styles.secondaryHeaderRow__name}>
				<TextMidCut
					tooltip
					autoTranslate="no"
					className={styles.secondaryHeaderRow__documentName}
					text={documentName}
				/>
			</div>
		</CustomTooltip>
	);
};
